import ServiceProviderDetailSidebar from './container'
export { ServiceProviderDetailSidebar }
export default ServiceProviderDetailSidebar